import { getCurrentHub, startTransaction } from '@sentry/browser';
import { Transaction } from '@sentry/tracing';

export function createTransaction(name: string, op: string, data?: any) {
  let transaction: Transaction | undefined;
  try {
    transaction = startTransaction({
      name,
      op,
      data,
    }) as Transaction;

    getCurrentHub()?.configureScope((scope) => scope.setSpan(transaction));

    return transaction;
  } catch (e) {
    console.error(e);

    return null;
  }
}
